var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-select',{attrs:{"options":_vm.options,"autofocus":_vm.autofocus},on:{"input":function($event){return _vm.$emit('input', $event)}},model:{value:(_vm.taskType),callback:function ($$v) {_vm.taskType=$$v},expression:"taskType"}})}
var staticRenderFns = []

export { render, staticRenderFns }